package com.example.event_management_system.ui.theme

import androidx.compose.ui.graphics.Color
import com.example.event_management_system.data.models.EventStatus

val EventStatus.statusColor: Color
    get() = when (this) {
        EventStatus.PENDING   -> EventPendingAccent
        EventStatus.CONFIRMED -> EventConfirmedAccent
        EventStatus.COMPLETED -> EventCompletedAccent
        EventStatus.CANCELLED -> EventCancelledAccent
    }
